import { Config } from "@config";
import { urlPreProcess } from "./url";

export const generateCtUrl = (url: string): string =>
	Config.getWpRestApiUrl("/ct", {
		url: urlPreProcess(url),
	});
